import VCol from './VCol.vue';

export { VCol };
export default VCol;
